<template>
  <div class="jnrh-container">
    <section class="common-section innovation-section">
      <section-title :titleInfo="innovationTitle"></section-title>
      <div class="innovation-layout">
        <div class="capability-grid">
          <article v-for="item in capabilities" :key="item.title" class="capability-card">
            <span class="feature-icon"><operation-icon :name="item.icon"></operation-icon></span>
            <div><h3>{{ item.title }}</h3><p>{{ item.text }}</p></div>
          </article>
        </div>
        <div class="hub-visual">
          <img class="hub-image" src="../images/jnrh/jnrh-hub.jpg" alt="交能融合综合能源站" />
          <div class="feature-scenes">
            <article v-for="item in features" :key="item.title">
              <img :src="item.image" :alt="item.title" />
              <strong>{{ item.title }}</strong>
            </article>
          </div>
        </div>
      </div>
    </section>

    <section class="common-section scene-section">
      <section-title :titleInfo="sceneTitle"></section-title>
      <div class="scene-grid">
        <article v-for="item in scenes" :key="item.title" class="scene-card">
          <img :src="item.image" :alt="item.title" />
          <div class="scene-copy">
            <span class="scene-icon"><operation-icon :name="item.icon"></operation-icon></span>
            <div><h3>{{ item.title }}</h3><p>{{ item.text }}</p></div>
          </div>
        </article>
      </div>
      <div class="value-grid">
        <article v-for="item in values" :key="item.title">
          <span class="value-icon"><operation-icon :name="item.icon"></operation-icon></span>
          <div><h3>{{ item.title }}</h3><p>{{ item.text }}</p></div>
        </article>
      </div>
    </section>

    <section class="contact-banner">
      <div>
        <h2>携手智融科技，共建绿色交能融合新生态</h2>
        <p>融合创新 · 协同发展 · 绿色未来</p>
      </div>
      <a href="tel:02583585700"><span>立即咨询</span><strong>025-83585700</strong></a>
    </section>
  </div>
</template>

<script>
import SectionTitle from "../../components/section-title.vue";
import OperationIcon from "./operation-icon.vue";

export default {
  name: "SjyyJnrh",
  components: { SectionTitle, OperationIcon },
  data() {
    return {
      innovationTitle: {
        bigtext1: "融合创新，驱动绿色未来",
        smallText: "打通能源与交通边界，构建高效协同的绿色出行与能源体系",
      },
      sceneTitle: {
        bigtext1: "多元场景应用，释放交能融合价值",
        smallText: "适配多种出行与能源场景，满足不同用户需求",
      },
      capabilities: [
        { title: "充储协同", text: "能量灵活调配，提升利用效率", icon: "battery" },
        { title: "智慧补能", text: "智能匹配需求，优化补能体验", icon: "charging" },
        { title: "园区联动", text: "能源交通协同，助力低碳园区", icon: "community" },
        { title: "路网协同", text: "路网能量协同，保障高效通行", icon: "highway" },
        { title: "绿色转型", text: "清洁能源驱动，实现低碳发展", icon: "green" },
        { title: "运营提效", text: "精细运营管理，提升综合效益", icon: "efficiency" },
      ],
      features: [
        { title: "光储充一体化", image: require("../images/jnrh/feature-solar-storage.jpg") },
        { title: "移动补能服务", image: require("../images/jnrh/feature-mobile-service.jpg") },
        { title: "重卡换电补能", image: require("../images/jnrh/feature-truck-energy.jpg") },
        { title: "智慧交通联动", image: require("../images/jnrh/feature-smart-traffic.jpg") },
      ],
      scenes: [
        { title: "园区出行", text: "便捷补能，绿色通勤", icon: "community", image: require("../images/jnrh/scene-campus.jpg") },
        { title: "物流枢纽", text: "协同调度，高效运营", icon: "truck-swap", image: require("../images/jnrh/scene-logistics.jpg") },
        { title: "高速服务区", text: "快速补能，畅行无忧", icon: "highway", image: require("../images/jnrh/scene-highway.jpg") },
        { title: "城市停车场", text: "智能充电，降碳增效", icon: "parking", image: require("../images/jnrh/scene-parking.jpg") },
        { title: "公共充电站", text: "智慧补能，体验升级", icon: "charging", image: require("../images/jnrh/scene-public-charging.jpg") },
        { title: "综合能源站", text: "多能互补，稳定供能", icon: "aggregate", image: require("../images/jnrh/scene-energy-hub.jpg") },
      ],
      values: [
        { title: "便捷补能", text: "随时随地，快速响应", icon: "charging" },
        { title: "协同调度", text: "多源协同，资源优化", icon: "schedule" },
        { title: "降碳增效", text: "绿色低碳，节能增效", icon: "green" },
        { title: "体验升级", text: "智慧服务，舒适便捷", icon: "shield" },
        { title: "多场景适配", text: "灵活配置，广泛应用", icon: "multi-scene" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.jnrh-container { width: 100%; color: #17233a; background: #fff; }
.common-section { box-sizing: border-box; padding: 100px clamp(32px, 8.33vw, 160px); }
.innovation-section { background: #f7f9fd; }
.innovation-layout { display: grid; grid-template-columns: minmax(440px, .78fr) minmax(600px, 1.22fr); gap: 36px; align-items: stretch; }
.capability-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; }
.capability-card { min-height: 150px; box-sizing: border-box; padding: 28px 24px; display: flex; align-items: center; gap: 20px; background: #fff; border: 1px solid #e7edf6; box-shadow: 0 10px 28px rgba(22, 74, 150, .06); }
.feature-icon, .scene-icon, .value-icon { display: grid; place-items: center; flex: none; color: #1f63ea; }
.feature-icon { width: 58px; height: 58px; }
h3, p { margin: 0; }
.capability-card h3 { margin-bottom: 10px; font-size: 20px; font-weight: 500; }
.capability-card p { color: #7d8797; font-size: 14px; line-height: 1.8; }
.hub-visual { min-width: 0; position: relative; overflow: hidden; background: #eaf2ff; }
.hub-image { width: 100%; height: 100%; min-height: 490px; display: block; object-fit: cover; }
.feature-scenes { position: absolute; right: 18px; bottom: 18px; left: 18px; display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; }
.feature-scenes article { height: 124px; overflow: hidden; position: relative; border: 2px solid rgba(255,255,255,.9); background: #0e54ca; }
.feature-scenes img { width: 100%; height: 100%; display: block; object-fit: cover; }
.feature-scenes article::after { content: ""; position: absolute; inset: 52% 0 0; background: linear-gradient(transparent, rgba(6,45,110,.94)); }
.feature-scenes strong { position: absolute; z-index: 1; right: 8px; bottom: 10px; left: 8px; color: #fff; font-size: 15px; font-weight: 500; text-align: center; }
.scene-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 26px; }
.scene-card { overflow: hidden; border: 1px solid #e5ebf4; background: #fff; box-shadow: 0 14px 32px rgba(22, 66, 133, .08); }
.scene-card > img { width: 100%; height: 245px; display: block; object-fit: cover; transition: transform .35s; }
.scene-card:hover > img { transform: scale(1.025); }
.scene-copy { min-height: 104px; box-sizing: border-box; padding: 22px 24px; display: flex; align-items: center; gap: 18px; }
.scene-icon { width: 44px; height: 44px; }
.scene-copy h3 { margin-bottom: 7px; font-size: 20px; font-weight: 500; }
.scene-copy p { color: #7d8797; font-size: 14px; }
.value-grid { margin-top: 38px; padding: 26px 30px; display: grid; grid-template-columns: repeat(5, 1fr); border: 1px solid #e7edf5; background: #f8faff; }
.value-grid article { min-width: 0; padding: 0 24px; display: flex; align-items: center; gap: 16px; border-right: 1px solid #dfe6f0; }
.value-grid article:last-child { border-right: 0; }
.value-icon { width: 44px; height: 44px; }
.value-grid h3 { margin-bottom: 6px; color: #1f63ea; font-size: 18px; font-weight: 500; }
.value-grid p { color: #7d8797; font-size: 12px; }
.contact-banner { min-height: 260px; box-sizing: border-box; padding: 54px clamp(32px, 8.33vw, 160px); display: flex; align-items: center; justify-content: space-between; gap: 40px; color: #fff; background: linear-gradient(90deg, rgba(5,68,178,.94), rgba(20,112,239,.78)), url('../images/jnrh/jnrh-banner.jpg') center 58% / cover no-repeat; }
.contact-banner h2 { margin: 0 0 16px; font-size: 34px; font-weight: 500; }
.contact-banner p { color: rgba(255,255,255,.8); font-size: 18px; }
.contact-banner a { min-width: 235px; padding: 16px 28px; display: flex; flex-direction: column; align-items: center; color: #1f63ea; border-radius: 4px; background: #fff; text-decoration: none; }
.contact-banner a span { margin-bottom: 6px; font-size: 15px; }
.contact-banner a strong { font-size: 22px; font-weight: 500; }
@media (max-width: 1200px) {
  .innovation-layout { grid-template-columns: 1fr; }
  .scene-grid { grid-template-columns: repeat(2, 1fr); }
  .value-grid { grid-template-columns: repeat(3, 1fr); gap: 24px 0; }
  .value-grid article:nth-child(3) { border-right: 0; }
}
@media (max-width: 720px) {
  .common-section { padding: 70px 24px; }
  .capability-grid, .scene-grid { grid-template-columns: 1fr; }
  .hub-image { min-height: 540px; }
  .feature-scenes { grid-template-columns: repeat(2, 1fr); }
  .value-grid { grid-template-columns: 1fr; }
  .value-grid article { border-right: 0; }
  .contact-banner { align-items: flex-start; flex-direction: column; }
}
</style>
